import React from 'react';
import {Modal, ModalBody, ModalFooter} from 'reactstrap';
import styles from './CollectionModal.scss';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';

const RemoveCollection = (props) => {

  const {
    showModal,
    toggleModal,
    onRemoveCollection,
    onRemoveFromCollection,
    onRemoveFromAllProperties,
    isFromFavouriteStar = false,
    isFromCollectionModal = false,
  } = props;

  return (
    <Modal
      zIndex="7000"
      isOpen={showModal}
      toggle={toggleModal}
      centered
      className={styles.addcreateModalContainer}
      modalClassName={styles.wrapClass}
      contentClassName={styles.modalContainer}
    >
      <ModalBody className={styles.modalBody}>
        <div className={styles.modalHead + ' border-bottom-0'} >
          <div className={styles.modalTitle + ' text-left font-weight-normal'}>
            <span>
              {isFromFavouriteStar || isFromCollectionModal ?
                'Do you want to remove this property?'
                :
                'Do you want to remove this collection?'
              }
            </span>
          </div>
          <button
            className={styles.actionButton + ' ' + styles.actionButtonDone}
            onClick={toggleModal}
          />

        </div>
        <div className={styles.modalContent + ' pb-3 pt-3 overflow-hidden'} id="body">
          {isFromFavouriteStar ?
            'You can remove this property from this collection or remove it from all the properties you have saved.'
            :
            <>
              { isFromCollectionModal ?
                'Removing this property from the ‘All Saved Properties’ list will also remove it from all collections where it is added. Are you sure you want to remove this property from all collections?'
                :
                'When you remove this collection, the properties will still be saved in all properties.'
              }
            </>
          }
        </div>
      </ModalBody>
      <ModalFooter className={'border-top-0'}>
        {isFromFavouriteStar || isFromCollectionModal ?
          <div className={'w-100 pt-1 pb-1 text-center'}>
            {isFromFavouriteStar &&
            <Button
              className={'ml-auto mr-auto mb-3 w-75'}
              variant={'contained'}
              color={'primary'}
              onClick={() => onRemoveFromCollection()}>
              Remove from Collection
            </Button>
            }
            <Button
              className={'mb-3 w-75'}
              variant={'outlined'}
              color={'secondary'}
              onClick={() => onRemoveFromAllProperties()}>
              Remove from All { isFromCollectionModal ? 'Collections' : 'Properties' }
            </Button>
            <div className={'d-block ml-auto mr-auto mt-3 mb-3 w-75 ' + styles.cancelButton} onClick={toggleModal}>
              Cancel
            </div>
          </div>
          :
          <div className={'d-flex w-100 pt-1 pb-1 justify-content-center align-items-center'}>
            <div className={'pl-4 pr-4 w-auto mr-2 ' + styles.cancelButton} onClick={toggleModal}>
              Cancel
            </div>

            <button className={'odinButton pl-4 pr-4 w-auto'} onClick={onRemoveCollection}>
              Remove
            </button>
          </div>
        }
      </ModalFooter>
    </Modal>
  );
}

RemoveCollection.propTypes = {
  showModal: PropTypes.bool,
  toggleModal: PropTypes.func,
  onRemoveCollection: PropTypes.func,
  onRemoveFromCollection: PropTypes.func,
  onRemoveFromAllProperties: PropTypes.func,
  isFromFavouriteStar: PropTypes.bool,
  isFromCollectionModal: PropTypes.bool,
};

export default RemoveCollection;